// extracted by mini-css-extract-plugin
module.exports = {"editManualIcon":"FillManuallyOption_editManualIcon__dTkXW"};